export default {
  title: "Calculation History",
  type: "Type",
  routeSearch: "Route Search",
  batchId: "Batch ID",
  createdAt: "Created At",
  totalDistance: "Total Distance (km)",
  productionEmission: "Production Emission (kg CO2e)",
  transportEmission: "Transport Emission (kg CO2e)",
  totalEmission: "Total Emission (kg CO2e)",
  taxInEUR: "Tax (€)",
  action: "Action",
  detail: "Detail",
  deleteConfirm: "Are you sure to delete this record?",
  data: "Data",
  reports: "Reports",
  batchDownload: "Batch Download",
  batchDownloadPdf: "Batch Download PDF",
  batchDownloadExcel: "Batch Download Excel",
  selectPlaceholder: "Please select at least one record",
  quotaInsufficient: "Insufficient quota, please upgrade or purchase",
  batchDownloadSuccess: "Batch download completed, selection reset",
  batchDownloadFailed: "Batch download failed",
  emptyFile: "Generated file is empty",
  downloadProgress: "Download Progress",
  completed: "completed",
  but: "but",
  regenerate: "Regenerate",
};
